"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiPolygonModel$ = exports.MultiPolygonModel$outboundSchema = exports.MultiPolygonModel$inboundSchema = void 0;
exports.multiPolygonModelToJSON = multiPolygonModelToJSON;
exports.multiPolygonModelFromJSON = multiPolygonModelFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.MultiPolygonModel$inboundSchema = z.object({
    coordinates: z.array(z.array(z.array(z.array(z.number())))),
    type: z.literal("MultiPolygon").default("MultiPolygon").optional(),
});
/** @internal */
exports.MultiPolygonModel$outboundSchema = z.object({
    coordinates: z.array(z.array(z.array(z.array(z.number())))),
    type: z.literal("MultiPolygon").default("MultiPolygon"),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var MultiPolygonModel$;
(function (MultiPolygonModel$) {
    /** @deprecated use `MultiPolygonModel$inboundSchema` instead. */
    MultiPolygonModel$.inboundSchema = exports.MultiPolygonModel$inboundSchema;
    /** @deprecated use `MultiPolygonModel$outboundSchema` instead. */
    MultiPolygonModel$.outboundSchema = exports.MultiPolygonModel$outboundSchema;
})(MultiPolygonModel$ || (exports.MultiPolygonModel$ = MultiPolygonModel$ = {}));
function multiPolygonModelToJSON(multiPolygonModel) {
    return JSON.stringify(exports.MultiPolygonModel$outboundSchema.parse(multiPolygonModel));
}
function multiPolygonModelFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.MultiPolygonModel$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'MultiPolygonModel' from JSON`);
}
//# sourceMappingURL=multipolygonmodel.js.map